import { Page } from '@/core/architecture'

import { StoreItemCompleteFreeTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StoreItemCompleteFree Page
 * Implemented as a practical sample.
 */
export const StoreItemCompleteFree: Page = () => {
  const { state, actions } = useViewModel()

  return <StoreItemCompleteFreeTemplate state={state} {...actions} />
}
